<template>
    <div class="gallery-block">
        <div v-if="number > 0">
        <v-layout wrap row>
            <v-flex v-for="i of number" :key="i" class="mt-3">
                <!-- <p class="white--text">Oil on canvas</p> -->
                <a data-fancybox="gallery" data-type="image" :href="`/img/gallery/${directory}/${i}.jpg`">
                    <div class="img-thumbnail">
                        <img :src="`/img/gallery/${directory}/${i}-th.jpg`" alt="art work" class="img-fluid">              
                    </div>
                </a>
            </v-flex>
        </v-layout>
        </div>
        <div v-else>
            <p>No images have been uploaded into this gallery yet</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['directory', 'number']
    }
</script>

<style>
    .gallery-block .img-thumbnail {
        margin-bottom: 5px;
    }
</style>
